import { Pipe, PipeTransform } from "@angular/core";
import { CalendarItem } from "@model/calendarItem";
import { Day } from "@model/day";

@Pipe({
    name: "calendarItemsDayPositionFilter", pure: false,
    standalone: false
})
export class CalendarItemsDayPositionFilter implements PipeTransform {
  transform(
    calendarItems: CalendarItem[],
    selectedDayIndex: number,
    position: number
  ): CalendarItem[] {
    return calendarItems.filter(
      i =>
        i.day.name === Day.DAYS[selectedDayIndex].name &&
        i.position === position
    );
  }
}
